/**
 * Region-aware base URL for API calls.
 *
 * The platform-admin SPA is identical in every region. At runtime, the
 * RegionProvider tells this store which regional backend the user is
 * currently viewing — every API call then routes there. In single-region
 * mode (one entry in the regions list), the base URL is the empty string
 * and calls go to the same origin the SPA was served from.
 *
 * Why a singleton store and not React context: most API helpers are plain
 * functions (e.g. ``getClients()``), not components, so they can't read
 * from a hook. The RegionProvider writes here; helpers read here.
 */
let _apiBaseUrl = '';

export function setApiBaseUrl(url: string): void {
    _apiBaseUrl = (url || '').replace(/\/+$/, '');
}

/**
 * Build an absolute URL for a relative API path. Passes through anything
 * already absolute (``http://…`` or ``https://…``) so callers that
 * construct full URLs by other means continue to work.
 */
export function withApiBaseUrl(path: string): string {
    if (/^https?:\/\//i.test(path)) return path;
    if (!_apiBaseUrl) return path;
    return `${_apiBaseUrl}${path.startsWith('/') ? '' : '/'}${path}`;
}
